import { render } from "./Gallery.vue?vue&type=template&id=2fd00a38"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=2fd00a38&lang=css"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\landing-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__